import React from "react";
import PropTypes from "prop-types";
import { hyphenateSync as hyphenate } from "hyphen/de";

const Hyphenate = ({ children, length, canIgnoreLength = false }) => {
  if (!children?.length) return;

  // Some Artist Names use special Characters instead of Spaces. If this happens, we change the minwordLength to let the single words break earlier.
  const ignoreLength = children.includes("/");

  let minWordLength = length;

  if (ignoreLength && canIgnoreLength) {
    minWordLength = 4;
  }

  return <>{hyphenate(children, { minWordLength: minWordLength })}</>;
};

Hyphenate.propTypes = {
  children: PropTypes.string.isRequired,
  length: PropTypes.number.isRequired,
  canIgnoreLength: PropTypes.bool,
};

export default Hyphenate;